import { apiClient } from "@api/client";
import { request } from "@api/request";
import type { components } from "@api/schema";
import { toClient, type Client } from "@patients/clientsClient";
import { toPatient, type Patient } from "@patients/patientsClient";
import { useQuery } from "@tanstack/react-query";

type HouseholdOut = components["schemas"]["HouseholdOut"];

export interface Household {
  id: string;
  label: string;
  primaryClientId: string | null;
  /** Primary first, as brian orders them. */
  clients: Client[];
  patients: Patient[];
}

const toHousehold = (h: HouseholdOut): Household => ({
  id: h.uuid,
  label: h.label,
  primaryClientId: h.primary_client_uuid,
  clients: h.clients.map(toClient),
  patients: h.patients.map(toPatient),
});

const getHousehold = (id: string): Promise<Household> =>
  request(() =>
    apiClient.GET("/households/{household_uuid}", {
      params: { path: { household_uuid: id } },
    }),
  ).then(toHousehold);

export const useHousehold = (id: string | null) =>
  useQuery({
    queryKey: ["households", id],
    queryFn: () => getHousehold(id!),
    enabled: id !== null,
  });
